export default "__VITE_ASSET__CTFY4y9B__"